import { version } from "./../../package.json";

const environments = Object.freeze({
  'dev': {
    title: "Development",
    name: "dev",
    color: "blue-grey",
    urlBack: "http://localhost:9191",
    path: "/",
    defaultLanguage: "en",
    trace: true,
    prefix: true
  },
  'qa-admin.ubunpay.com': {
    title: "QA Ubuntec",
    name: "qa",
    color: "light-blue",
    urlBack: "https://qa-bizlogic-abxbiz-back.ubunpay.com",
    path: "/",
    defaultLanguage: "en",
    trace: true,
    prefix: true
  },
  'admin.ubunpay.net': {
    title: "PROD Ubuntec",
    name: "prod",
    color: "green",
    urlBack: "https://bizlogic-abxbiz-back.ubunpay.net",
    path: "/",
    defaultLanguage: "en",
    trace: false,
    prefix: false
  }
});

export const environment = Object.freeze({
  global: {
    name: 'ABXBIZ'
  },
  endpoint: environments[window.location.hostname] ?? environments.dev,
  version: version,
});
